function normalizePath(value: string): string {
  const path = value.split(/[?#]/)[0];
  return path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
}

function isInternal(href: string): boolean {
  return !!href && href !== "#" && !/^(https?:|mailto:|tel:)/i.test(href);
}

export function isActiveHref(href: string, pathname: string): boolean {
  if (!isInternal(href)) return false;
  return normalizePath(href) === normalizePath(pathname);
}

// Looser match for top-level nav: active on the section page or any child of it.
export function isActiveSection(href: string, pathname: string): boolean {
  if (!isInternal(href)) return false;
  const h = normalizePath(href);
  const p = normalizePath(pathname);
  return p === h || p.startsWith(`${h}/`);
}
